export const GLOSSARY_OPTIONS = [
  '0-9',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const GLOSSARY_BREADCRUMBS = [
  {
    text: 'Learning Center',
    disabled: false,
    to: '/',
  },
  {
    text: 'Glossary',
    disabled: true,
    to: '/glossary',
  },
];

export const REDIRECT_VALID_DOMAINS = [
  'greenstreet.com',
  'greenstreetapps.com',
];

export const LS_PREVIOUS_LINK_KEY = 'previousLink';
